import Select from 'react-select';
import {useTranslation} from "react-i18next";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';

export const InputDateRangeMulti = (args) => {
    const {register, setValue, watch, placeholder, errors, nameStart, nameEnd, label, isRequired = true} = args

    const handleDateRangeChange = (event, picker) => {
        console.log('handleDateRangeChange');
        const startDate = picker.startDate.format('YYYY-MM-DD');
        const endDate = picker.endDate.format('YYYY-MM-DD');
        // const dateRangeValue = `${startDate} - ${endDate}`;

        setValue(nameStart, startDate, {shouldValidate: true});
        setValue(nameEnd, endDate, {shouldValidate: true});
    };

    const currentStartValue = watch(nameStart);
    const currentEndValue = watch(nameEnd);

    return (
        <div className='mb-3 datemultipicker-input'>
            <label htmlFor={nameStart}>{label}</label>
            <DateRangePicker onApply={handleDateRangeChange}>
                <div>
                    <input
                        {...register(nameStart, isRequired && {required: `${label} is required`})}
                        type='text'
                        value={currentStartValue}
                        placeholder={`${placeholder}`}
                        className='form-control daterange-input dateEnd'
                    />
                    <div className='daterange-seperator'>-</div>
                    <input
                        {...register(nameEnd, isRequired && {required: `${label} is required`})}
                        type='text'
                        value={currentEndValue}
                        placeholder={`${placeholder}`}
                        className='form-control daterange-input dateStart'
                    />
                </div>
            </DateRangePicker>
            {errors && errors[nameStart] && (
                <span className='text-danger'>{errors[nameStart].message}</span>
            )}
        </div>
    );
};
export const InputText = (args) => {
    const {register, placeholder, errors, name, lang = "", label, isRequired = true} = args
    const {t} = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{`${t(label)}${lang ? ` (${lang.toUpperCase()})` : ''}`}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='text'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}
export const InputUrl = (args) => {
    const {register, placeholder, errors, name,lang = "", label, isRequired = true} = args
    const {t} = useTranslation();
    return (
        <div className='mb-3'>
            <label htmlFor={name}>{`${t(label)}${lang ? ` (${lang.toUpperCase()})` : ''}`}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='url'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}
export const InputTel = (args) => {
    const {register, placeholder, errors, name, label, isRequired = true} = args

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{label}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='tel'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}
export const InputTime = (args) => {
    const {register, placeholder, errors, name, label,lang = "", isRequired = true} = args
    const {t} = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{`${t(label)}${lang ? ` (${lang.toUpperCase()})` : ''}`}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='time'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}
export const InputTextArea = (args) => {
    const {register, placeholder, errors, name, label, lang = "", isRequired = true} = args
    const {t} = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{`${t(label)}${lang ? ` (${lang.toUpperCase()})` : ''}`}</label>
            <textarea
                rows='5'
                cols='30'
                {...register(name, isRequired && {required: `${label} is required`})}
                type='text'
                placeholder={`${t(placeholder)}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const InputNumber = (args) => {
    const {register, placeholder, errors, name, label, lang = "", isRequired = true} = args
    const {t} = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{`${t(label)}${lang ? ` (${lang.toUpperCase()})` : ''}`}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='number'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const InputEmail = (args) => {
    const {register, placeholder, errors, label, name, isRequired = true} = args
    const {t} = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{t(label)}</label>
            <input
                {...register(name, {
                    required: isRequired ? `${label} is required` : null,
                    pattern: {
                        value: /\S+@\S+\.+\S+/,
                        message: t('Entered value does not match email format'),
                    },
                })}
                type='email'
                placeholder={`${t(placeholder)}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const InputPassword = (args) => {
    const {
        register,
        placeholder,
        errors,
        watch,
        name,
        label,
        validate = false,
        isRequired = true,
        minLength = false,
    } = args
    const { t } = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{t(label)}</label>
            <input
                {...register(name, {
                    required: isRequired ? `${label} is required` : null,
                    minLength: minLength
                        ? {
                            value: 6,
                            message: t('Password must have at least 6 characters'),
                        }
                        : null,
                    validate: validate
                        ? (value) =>
                            value === watch().password || t('The passwords do not match')
                        : null,
                })}
                type='password'
                placeholder={`${t(placeholder)}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const DynamicInputSelect = (args) => {
    const {
        register,
        placeholder,
        errors,
        name,
        label,
        data,
        isRequired = true,
        value,
        translated = false,
        id = '_id',
    } = args

    const {t, i18n} = useTranslation();
    const currentLanguage = i18n.language;
    return (
        <div className='mb-3'>
            <label htmlFor={name}>{t(label)}</label>
            <select
                {...register(name, isRequired && {required: `${label} is required`})}
                type='text'
                placeholder={`${t(placeholder)}`}
                className='form-control'
            >
                <option value=''>- - - - -</option>
                {data &&
                    data.map((d) => (
                        <option key={d[id]} value={d[id]}>
                            {translated ? (d[value][currentLanguage] || d[value]['en']) : d[value]}
                        </option>
                    ))}
            </select>
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

// export const DynamicInputSelectWithIconBasedOnId = (args) => {
//     const {
//         register,
//         placeholder,
//         errors,
//         name,
//         label,
//         data,
//         isRequired = true,
//         value,
//         id = '_id',
//         media_path = '../../img/',
//
//     } = args
//
//     const defaultIconById = '../../img/'+ media_path +'/default.png';
//
//     return (
//         <div className='mb-3'>
//             <label htmlFor={name}>{label}</label>
//             <select
//                 {...register(name, isRequired && { required: `${label} is required` })}
//                 type='text'
//                 placeholder={`${placeholder}`}
//                 className='form-control'
//             >
//                 <option value=''>-------</option>
//                 {data &&
//                     data.map((d) => (
//                         <option key={d[id]} value={d[id]}>
//                             {d[value]}
//                             <img
//                                 src={require('${media_path}/${d[id]}.png').default}
//                                 onError={(e) => { e.target.src = defaultIconById; }}
//                                 alt='Icon'
//                             />
//                         </option>
//                     ))}
//             </select>
//             {errors && errors[name] && (
//                 <span className='text-danger'>{errors[name].message}</span>
//             )}
//         </div>
//     )
// }
export const DynamicInputMultiSelect = (args) => {


    // ABANDONED - USE DYNAMICEXTRAFORM


    const {
        register,
        placeholder,
        errors,
        name,
        label,
        data,
        isRequired = true,
        value,
        id = '',
    } = args;

    return (
        <div className='mb-3'>
            {/*{console.log(data)}*/}
            <label htmlFor={name}>{label}</label>
            <Select
                {...register(name, isRequired && {required: `${label} is required`})}
                id={id}
                placeholder={`${placeholder}`}
                className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
                options={data}
                isMulti
                getOptionValue={(option) => option.value}
                getOptionLabel={(option) => option[value]}
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    );
};
export const StaticInputSelect = (args) => {
    const {
        register,
        placeholder,
        errors,
        name,
        data,
        label,
        isRequired = true,
    } = args

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{label}</label>
            <select
                {...register(name, isRequired && {required: `${label} is required`})}
                type='text'
                placeholder={`${placeholder}`}
                className='form-control'
            >
                <option value=''>-------</option>
                {data &&
                    data.map((d) => (
                        <option key={d.name} value={d.name}>
                            {d.name}
                        </option>
                    ))}
            </select>
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}
export const InputCheckBox = (args) => {
    const {register, errors, name, label, isRequired = true} = args

    return (
        <div className='mb-3'>
            <div className='form-check form-switch'>
                <input
                    className='form-check-input'
                    type='checkbox'
                    id={name}
                    {...register(
                        name,
                        isRequired && {required: `${label} is required`}
                    )}
                />
                <label className='form-check-label' htmlFor={name}>
                    {label}
                </label>
            </div>
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const InputMultipleCheckBox = (args) => {
    const {register, errors, name, data, label, isRequired = true} = args

    return (
        <div className='mb-3'>
            <div className='row g-1 mb-3'>
                {data &&
                    data.map((d) => (
                        <div key={d._id} className='col-md-4 col-6'>
                            <div className='form-check form-switch'>
                                <input
                                    {...register(
                                        name,
                                        isRequired && {required: `${label} is required`}
                                    )}
                                    className='form-check-input'
                                    type='checkbox'
                                    value={d._id}
                                    id={`flexCheck${d._id}`}
                                />
                                <label
                                    className='form-check-label'
                                    htmlFor={`flexCheck${d._id}`}
                                >
                                    {d.name}
                                </label>
                            </div>
                        </div>
                    ))}
            </div>
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const InputFile = (args) => {
    const {
        register,
        placeholder,
        errors,
        name,
        isRequired = true,
        label,
        setFile,
    } = args

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{label}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='file'
                placeholder={`${placeholder}`}
                className='form-control'
                id='formFile'
                onChange={(e) => setFile(e.target.files[0])}
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const InputDate = (args) => {
    const {register, placeholder, errors, name, label, lang = "", isRequired = true} = args
    const {t} = useTranslation();

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{`${t(label)}${lang ? ` (${lang.toUpperCase()})` : ''}`}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='date'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}


export const InputAutoCompleteSelect = (args) => {
    const {
        register,
        placeholder,
        errors,
        name,
        data,
        label,
        isRequired = true,
    } = args

    return (
        <div className='mb-3'>
            <label htmlFor='exampleDataList' className='form-label'>
                {label}
            </label>
            <input
                list='datalistOptions'
                autoComplete='off'
                id='exampleDataList'
                {...register(name, isRequired && {required: `${label} is required`})}
                type='text'
                placeholder={`${placeholder}`}
                className='form-control'
            />
            <datalist id='datalistOptions'>
                <option value=''>-------------</option>
                {data &&
                    data.map((d) => (
                        <option key={d._id} value={d._id}>
                            {d.name}
                        </option>
                    ))}
            </datalist>

            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const DynamicInputSelectNumber = (args) => {
    const {
        register,
        placeholder,
        errors,
        name,
        label,
        data,
        isRequired = true,
    } = args

    return (
        <div className='mb-3'>
            <label htmlFor={name}>{label}</label>
            <select
                {...register(name, isRequired && {required: `${label} is required`})}
                type='text'
                placeholder={`${placeholder}`}
                className='form-control'
            >
                <option value=''>-------</option>

                {[...Array(data).keys()].map((num) => (
                    <option key={num + 1} value={num + 1}>
                        {num + 1}
                    </option>
                ))}
            </select>
            {errors && errors[name] && (
                <span className='text-danger'>{errors[name].message}</span>
            )}
        </div>
    )
}

export const FileUploaderField = (
    {
        register,
        name,
        label,
        handleImageChange,
        // setValue,
        // watch,
        isRequired = false,
    }) => {

    return (
        <div>
            <label htmlFor={name}>{label}</label>
            <input
                {...register(name, isRequired && {required: `${label} is required`})}
                type='file'
                id={name}
                name={name}
                onChange={(e) => handleImageChange(e, name)}/>
        </div>
    );
};